<script setup>
const props = defineProps({
    id: { type: Number, required: true }
});
</script>

<template>
    <purchase-button-base
        :request-url="route('courses.purchaseWithLead', id)"
        @success="$document.locationAssign(route('courses.show', id))"
    >
        <template #default><slot></slot></template>
    </purchase-button-base>
</template>
